/* tslint:disable */
/* eslint-disable */
/**
 * MinSide.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OrganizationGroupType } from './OrganizationGroupType';
import {
    OrganizationGroupTypeFromJSON,
    OrganizationGroupTypeFromJSONTyped,
    OrganizationGroupTypeToJSON,
    OrganizationGroupTypeToJSONTyped,
} from './OrganizationGroupType';

/**
 * 
 * @export
 * @interface OrganizationGroupResponse
 */
export interface OrganizationGroupResponse {
    /**
     * 
     * @type {string}
     * @memberof OrganizationGroupResponse
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OrganizationGroupResponse
     */
    name?: string | null;
    /**
     * 
     * @type {any}
     * @memberof OrganizationGroupResponse
     */
    organizationGroupId?: any | null;
    /**
     * 
     * @type {string}
     * @memberof OrganizationGroupResponse
     */
    shortName?: string | null;
    /**
     * 
     * @type {OrganizationGroupType}
     * @memberof OrganizationGroupResponse
     */
    organizationGroupType?: OrganizationGroupType;
}



/**
 * Check if a given object implements the OrganizationGroupResponse interface.
 */
export function instanceOfOrganizationGroupResponse(value: object): value is OrganizationGroupResponse {
    return true;
}

export function OrganizationGroupResponseFromJSON(json: any): OrganizationGroupResponse {
    return OrganizationGroupResponseFromJSONTyped(json, false);
}

export function OrganizationGroupResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrganizationGroupResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'description': json['description'] === undefined ? undefined : json['description'] === null ? null : json['description'],
        'name': json['name'] === undefined ? undefined : json['name'] === null ? null : json['name'],
        'organizationGroupId': json['organizationGroupId'] === undefined ? undefined : json['organizationGroupId'] === null ? null : json['organizationGroupId'],
        'shortName': json['shortName'] === undefined ? undefined : json['shortName'] === null ? null : json['shortName'],
        'organizationGroupType': json['organizationGroupType'] == null ? undefined : OrganizationGroupTypeFromJSON(json['organizationGroupType']),
    };
}

export function OrganizationGroupResponseToJSON(json: any): OrganizationGroupResponse {
    return OrganizationGroupResponseToJSONTyped(json, false);
}

export function OrganizationGroupResponseToJSONTyped(value?: OrganizationGroupResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'description': value['description'],
        'name': value['name'],
        'organizationGroupId': value['organizationGroupId'],
        'shortName': value['shortName'],
        'organizationGroupType': OrganizationGroupTypeToJSON(value['organizationGroupType']),
    };
}

